<template>
  <aard-van-de-plechtigheid/>
</template>

<script>
import AardVanDePlechtigheid from '../components/OpbouwPlechtigheid/AardVanDePlechtigheid.vue'

export default {
  name: 'AardVanDePlechtigheidView',
  components: {
    AardVanDePlechtigheid
  }
}
</script>
